import React from "react";

const FileTableSkeleton: React.FC = () => {
  return (
    <table className="w-full table-auto text-sm 2xl:text-base">
      <thead>
        <tr className="text-left border-b-2 border-[#f9fafb]">
          <th className="py-3 px-4"></th>
          <th className="py-3 px-4 text-slate-700">
            <div className="w-20 h-4 bg-gray-200 rounded"></div>
          </th>
          <th className="py-3 px-4 text-slate-700">
            <div className="w-12 h-4 bg-gray-200 rounded"></div>
          </th>
          <th className="py-3 px-4 text-slate-700">
            <div className="w-16 h-4 bg-gray-200 rounded"></div>
          </th>
          <th className="py-3 px-4 text-slate-700">
            <div className="w-20 h-4 bg-gray-200 rounded"></div>
          </th>
          <th className="py-3 px-4 text-slate-700">
            <div className="w-24 h-4 bg-gray-200 rounded"></div>
          </th>
          <th className="py-3 px-4 text-slate-700 text-center">
            <div className="w-5 h-5 bg-gray-200 rounded-full mx-auto"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        {[1, 2].map((row) => (
          <tr
            key={row}
            className="transition-colors duration-200 border-b-2 border-[#f9fafb] group bg-white animate-pulse"
          >
            <td className="py-3 px-4"></td>
            <td className="py-3 px-4">
              <div className="flex items-center my-1 space-x-3">
                <div className="w-7 h-7 bg-gray-200 rounded" />
                <div className="flex-1">
                  <div className="w-40 h-4 bg-gray-200 rounded mb-1"></div>
                </div>
              </div>
            </td>
            <td className="py-3 px-4">
              <div className="w-12 h-4 bg-gray-200 rounded"></div>
            </td>
            <td className="py-3 px-4">
              <div className="w-16 h-4 bg-gray-200 rounded"></div>
            </td>
            <td className="py-3 px-4">
              <div className="w-20 h-4 bg-gray-200 rounded"></div>
            </td>
            <td className="py-3 px-4">
              <div className="w-24 h-4 bg-gray-200 rounded"></div>
            </td>
            <td className="py-3 px-4 text-center">
              <div className="w-5 h-5 bg-gray-200 rounded-full mx-auto"></div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FileTableSkeleton;
